"use client";

import Link from "next/link";
import Image from "next/image";
import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { useInViewAnimation } from "../animation/useInViewAnimation";
import { useTranslation } from "next-i18next";

export default function Katalog() {
  const ref = useRef(null);
  const inView = useInViewAnimation(ref);
  const [buttonHover, setButtonHover] = useState(false);
  const { t } = useTranslation("katalog");

  const images = [
    "/img/katalog/IMG_0866.JPG",
    "/img/katalog/IMG_0867.JPG",
    "/img/katalog/IMG_0868.JPG",
    "/img/katalog/IMG_0869.JPG",
    "/img/katalog/IMG_0870.JPG",
    "/img/katalog/IMG_0871.JPG",
    "/img/katalog/IMG_0872.jpg",
    "/img/katalog/IMG_0873.JPG",
  ];

  return (
    <section
      id="products"
      ref={ref}
      className="bg-reefliBeige py-14 px-4 md:px-20 text-center font-[futura] text-[#262104]"
    >
      <motion.h2
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
        className="text-2xl md:text-3xl font-semibold"
      >
        {t("title")}
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="text-lg mt-4 max-w-3xl mx-auto text-center w-full"
      >
        {t("description")}
        <br />
        <br />
        {t("info")}
      </motion.p>

      <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 place-items-center">
        {images.map((src, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="rounded-2xl overflow-hidden shadow-lg bg-white w-[150px] h-[150px] md:w-[200px] md:h-[200px] flex items-center justify-center transform transition-transform duration-300 hover:scale-105"
          >
            <Image
              src={src}
              alt={`Produkt ${index + 1}`}
              width={200}
              height={200}
              className="object-cover w-full h-full"
              loading="lazy"
            />
          </motion.div>
        ))}
      </div>
    </section>
  );
}
